import React from 'react';
import {
	NavigationStepperComponentParams,
	NavigationStepperItemType,
} from '../../../../Components/Stepper/NavigationStepper';
import SubTabNavigationStepper from '../../../../Components/Stepper/SubTabNavigationStepper/SubTabNavigationStepper';
import NCZIPatient from '../../../Nczi/Components/NCZIPatient/NCZIPatient';
import ElectronicPrescriptionList from '../../../Nczi/Components/ElectronicPrescription/List/ElectronicPrescriptionList';
import NCZIInsuredPatient from '../../../Nczi/Components/NCZIPatient/NCZIInsuredPatient';
import ElectronicPrescriptionMedication from '../../../Nczi/Components/ElectronicPrescription/Medication/ElectronicPrescriptionMedication';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
	workplaceId: string;
}

const ElectronicPrescription: React.FC<Props> = ({
	setIsLoading,
	workplaceId,
}) => {
	const steps: NavigationStepperItemType[] = [
		{
			name: 'patientTreatment.electronicPrescription.list.title',
			key: 'list',
			component: (params: NavigationStepperComponentParams) => (
				<NCZIPatient skipPatientIdentifier>
					<NCZIInsuredPatient>
						<ElectronicPrescriptionList
							setIsLoading={setIsLoading}
							workplaceId={workplaceId}
						/>
					</NCZIInsuredPatient>
				</NCZIPatient>
			),
		},
		{
			name: 'patientTreatment.electronicPrescription.medication.title',
			key: 'medication',
			component: (params: NavigationStepperComponentParams) => (
				<NCZIPatient skipPatientIdentifier>
					<ElectronicPrescriptionMedication setIsLoading={setIsLoading} />
				</NCZIPatient>
			),
		},
	];

	return (
		<>
			<SubTabNavigationStepper
				steps={steps}
				initialStepPath='list'
				canSkip={true}
			/>
		</>
	);
};

export default ElectronicPrescription;
